import React from 'react'

export default function LiveScoresInlineNewWh(props) {
    const score = props.data;
    const sportType = props.sportType
    const notTotalScoresArray = score.formattedScores.filter(formattedScore => !formattedScore.isTotalScore)
    const totalScoresArray = score.formattedScores.filter(formattedScore => formattedScore.isTotalScore)
    return (
        <>
            <div className='scoreWrapper-inline'>
                <div className='notTotalScoreWrapper'>
                    {notTotalScoresArray.map((e, i) => {

                        return  <React.Fragment key={`${i}-notTotal`}>
                        <div key={i} className={`type-${sportType} notTotalScore score__wrapper-col`}>
                                <div className='score__round-s1'>{e.s1}</div>
                                <div className='score__round-s2'>{e.s2}</div>
                            </div>
                            {e.p == 'G' &&
                                <div className={`type-${sportType} game__set score__wrapper-col`}>
                                    <div className='score__round-s1'>{e.s1}</div>
                                    <div className='score__round-s2'>{e.s2}</div>
                                </div>
                            }
                        </React.Fragment>
                    })}
                </div>
                {totalScoresArray.map((e, i) => {
                    return <div key={i} className={`type-${sportType} totalScore score__wrapper-col`}>
                        <div className='score__s1'>{e.s1}</div>
                        <div className='score__s2'>{e.s2}</div>
                    </div>
                })}
            </div>
        </>
    );
}
